import { render } from "./order_dtl.vue?vue&type=template&id=9c6e0cb8&scoped=true"
import script from "./order_dtl.vue?vue&type=script&lang=js"
export * from "./order_dtl.vue?vue&type=script&lang=js"

import "./order_dtl.vue?vue&type=style&index=0&id=9c6e0cb8&scoped=true&lang=css"
import "./order_dtl.vue?vue&type=style&index=1&id=9c6e0cb8&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c6e0cb8"]])

export default __exports__